import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { getBranches } from '../../Features/Shared/Locations/locationSlice';
import { getSales } from '../../Features/SalesDep/Sales/SalesSlice';
import { getBids } from '../../Features/SalesDep/Bids/BidSlice';
// import { getTemplates } from 'Features/SalesDep/Templates/TemplateSlice';
// import { getCustomers } from 'Features/Shared/Customers/CustomerSlice';
import { getAccount } from '../../Features/Shared/Account/AccountSlice';
import { getSellAThon } from '../../Features/SalesDep/Sales/SellAThonSlice';
import { getCustomers } from '../../Features/Shared/Customers/CustomerSlice';
import { clearSalesRepWriter } from '../../Features/SalesDep/Managers/SalesRepView/WriterSlice';
import { getOrders } from '../../Features/SalesDep/Orders/OrderSlice';
import { getTodo } from '../../Features/SalesDep/To-Do List/TodoSlice';
import { getNotifs } from '../../Features/Shared/Push Notifications/PushNotificationSlice';

export const salesBootstrap = createAsyncThunk<
    any,
    void,
    { state: RootState }
>(
    'bootstrap/refreshAppBootstrap',
    async (_, { dispatch, getState }) => {
        const state = getState();

        if (!state.auth.isAuthorized) return;

        await Promise.all([
            dispatch(getSales({})),
            dispatch(getBranches()),
            dispatch(getOrders({ })),
            dispatch(getBids({ })),
            // dispatch(getTemplates()),
            dispatch(getCustomers({})),
            dispatch(getAccount()),
            dispatch(getSellAThon({})),
            dispatch(getTodo({})),
            dispatch(clearSalesRepWriter()),
            dispatch(getNotifs()),
        ]);
    }
);